exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ccm-client-settings--188TD3I4hDniCU9O6WdqzH {\n  display: flex;\n  flex-direction: column;\n  margin: 0 0 16px 16px;\n}\n\n.ccm-client-settings--3d5OjBNkKQLkPP9hrS8nk {\n  display: flex;\n  flex-direction: column;\n  margin: 5px 0px 0px 25px;\n}\n", ""]);

// exports
exports.locals = {
	"errorsContainer": "ccm-client-settings--188TD3I4hDniCU9O6WdqzH",
	"errorsContainer": "ccm-client-settings--188TD3I4hDniCU9O6WdqzH",
	"errorInfo": "ccm-client-settings--3d5OjBNkKQLkPP9hrS8nk",
	"errorInfo": "ccm-client-settings--3d5OjBNkKQLkPP9hrS8nk"
};